// Generated by scripts/sync-freecut-editor.mjs; do not edit.
/** FreeCut commit vendored in public/freecut/. */
export const FREECUT_COMMIT = 'ea248dfe4bc37df2bf9195dcee56fddb822b66b5';
/** onnxruntime-web build the vendored editor expects for its AI features. */
export const ONNX_RUNTIME_WEB_VERSION = '1.31.0-dev.20260914-8d85527a0';
